import React, { useEffect, useState } from "react";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import {
  differenceInYears,
  differenceInMonths,
  parseISO,
  isValid,
} from "date-fns";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const BenchTrackerReport = () => {
  const [benchTracker, setbenchTracker] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [countData, setCountData] = useState("");
  const [apiStatus, setApiStatus] = useState(undefined);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Bench Tracker Report"));
  }, []);

  const columns = {
    Code: { text: "EMP ID", visible: true },
    EmployeeName: { text: "Employee", visible: true },
    PrimarySkillName: { text: "Primary Skills", visible: true },
    SecondarySkillName: { text: "Secondary Skills", visible: true },
    lastToDate: { text: "Total Exp", align: "center", visible: true },
    lastFromDate: { text: "Relevant Exp", align: "center", visible: true },
    ReportingHead: { text: "Reporting Head", visible: true },
    MostRecentDate: {
      text: "On Bench Since Date",
      align: "center",
      visible: true,
    },
    CurrentStatus: { text: "Current Status", visible: true },
  };

  useEffect(() => {
    fetchbenchTracker();
  }, []);

  const fetchbenchTracker = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}rom-report/2`);
      setApiStatus(response?.status);
      if (response.status === 200) {
        const benchTracker = response?.data?.header;
        const dateConvert = benchTracker.map((item) => {
          const from = item.lastFromDate ? parseISO(item.lastFromDate) : null;
          const to = item.lastToDate ? parseISO(item.lastToDate) : null;
          const mostRecent = item.MostRecentDate
            ? parseISO(item.MostRecentDate)
            : null;

          let relevantExperience = "";
          let benchExperience = "";

          if (from && to && isValid(from) && isValid(to)) {
            let years = differenceInYears(to, from);
            let months = differenceInMonths(to, from) % 12;

            if (months < 0) {
              years -= 1;
              months += 12;
            }

            relevantExperience = `${years} yr ${months} m`;
          }

          if (from && mostRecent && isValid(from) && isValid(mostRecent)) {
            let years = differenceInYears(mostRecent, from);
            let months = differenceInMonths(mostRecent, from) % 12;

            if (months < 0) {
              years -= 1;
              months += 12;
            }

            benchExperience = `${years} yr ${months} m`;
          }

          return {
            ...item,
            lastFromDate: relevantExperience,
            lastToDate: benchExperience, // Add this field to store MostRecentDate - lastFromDate calculation
          };
        });
        setbenchTracker(dateConvert);
        setCountData(response.data.header.length);
      } else {
        console.error(
          "Failed to fetch Course. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Course:", error);
    }
  };
const ReadOnlyValues = [{
  label:"Total Employee ",value:countData ||0,
}]
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={benchTracker}
              isRequiredStatus={true}
              ReadOnlyValues={ReadOnlyValues}
              isApiStatus={apiStatus}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isSorting={true}
              add
              more
              function
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default BenchTrackerReport;
